export default __webpack_public_path__ + "static/media/london.2a7e23f7.jpg";